import { useState } from "react";
import emailjs from "emailjs-com";

const initialState = {
  fullName: "",
  title: "",
  organization: "",
  email: "",
  phone: "",
  businessType: "Home Baker",
  flourUsage: "Less than 100lbs",
  province: "",
  message: "",
};

export const Contact = (props) => {
  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const clearState = () => setFormData(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", e.target, "YOUR_PUBLIC_KEY")
      .then(
        (result) => {
          console.log("SUCCESS!", result.text);
          clearState();
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <div
      id="contact"
      style={{
        padding: "60px 20px",
        fontFamily: "Arial",
        borderTop: "1px solid #DDD",
        backgroundColor: "#fff",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <h2
          style={{
            fontSize: "2.4rem",
            fontWeight: "700",
            marginBottom: "40px",
            color: "#111827",
            position: "relative",
            textAlign: "center",
          }}
        >
          Contact Us
          <span
            style={{
              position: "absolute",
              width: "120px",
              height: "4px",
              backgroundColor: "#C38745",
              left: "50%",
              bottom: -10,
              transform: "translateX(-50%)",
            }}
          ></span>
        </h2>

        <div className="contact-container">
          {/* LEFT SIDE */}
          <div className="contact-left" style={{ color: '#2C3639' }}>

            <h4>General Inquiries</h4>
            <p><strong>Email:</strong> <a href="mailto:info@tahilgroup.ca">info@tahilgroup.ca</a></p>
            {/* <p><strong>Mobile:</strong> +1 (403)-426-6111</p> */}

            <br />

            <h4>Commercial Inquiries:</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div>
                <p><strong>- Sales : </strong>Murad Heydarov</p>
                <p><strong>Email:</strong> <a href="mailto:murad@tahilgroup.ca">murad@tahilgroup.ca</a></p>
                <p><strong>Mobile:</strong> +1 (403)-426-4111</p>
              </div>

              <div>
                <p><strong>- Procurement : </strong>Otajon Tashpulatov</p>
                <p><strong>Email:</strong> <a href="mailto:otajon@tahilgroup.ca">otajon@otifoods.com</a></p>
                <p><strong>Mobile:</strong> +1 (403)-448-7111</p>
              </div>
            </div>

            <br />

            <h4>Locations</h4>
            <p><strong>Administrative Office:</strong><br />
              • 4089N-8500 Macleod Tr., Calgary, AB T2H 2N1
            </p>

            <p><strong>Production Facilities:</strong><br />
              • 2 Wyndham Way, Acme, AB T0M 0A0, Canada<br />
              • 700 1 Ave NW, Linden, AB T0M 1J0, Canada
            </p>

            <br />

            {/* <p><strong>Salespoint:</strong> <a href="https://www.otifoods.ca">www.tahilgroup.ca/otifood</a></p> */}

            <div style={{ margin: '20px 0 0 0' }}>
              <a href={props.data?.linkedin || "/"} target="_blank" rel="noreferrer">
                <i className="fa fa-linkedin" style={{ fontSize: "4.1rem" }}></i>
              </a>
            </div>
          </div>


          {/* RIGHT SIDE */}
          <div className="contact-right">
            <form onSubmit={handleSubmit}>
              {[
                { name: "fullName", label: "Your Name", type: "text" },
                { name: "title", label: "Title / Position", type: "text" },
                { name: "organization", label: "Company / Organization", type: "text" },
                { name: "email", label: "Email Address", type: "email" },
                { name: "phone", label: "Phone", type: "tel" },
                { name: "province", label: "Province / State", type: "text" },
              ].map((field) => (
                <div key={field.name} style={{ marginBottom: "15px" }}>
                  <input
                    name={field.name}
                    placeholder={field.label}
                    type={field.type}
                    value={formData[field.name]}
                    onChange={handleChange}
                    required
                    style={{
                      width: "100%",
                      padding: "12px",
                      fontSize: "1.1rem",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      boxSizing: "border-box",
                      color: '#000'
                    }}
                  />
                </div>
              ))}

              <div style={{ marginBottom: "20px" }}>
                <textarea
                  name="message"
                  rows={5}
                  placeholder="Your Questions/Comments (optional)"
                  value={formData.message}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "12px",
                    fontSize: "1rem",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    resize: "vertical",
                    boxSizing: "border-box",
                    color: '#000'
                  }}
                />
              </div>

              <button
                type="submit"
                style={{
                  background: "linear-gradient(to right,rgb(202, 150, 78), #C38745)",
                  color: "#fff",
                  padding: "14px",
                  border: "none",
                  fontWeight: "bold",
                  cursor: "pointer",
                  width: "100%",
                  fontSize: "1rem",
                  borderRadius: "4px",
                }}
              >
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
